import React, { useEffect, useState } from "react";
import TrackingTemplete from "../../components/TrackingTemplete";
import { DsersTrackingCoreV1GetTrackingPageInlineReply } from "../../components/TrackingTemplete/interface";
const currenctColor: Record<string, string> = {
  ColorSet_Black: "#25282C",
  ColorSet_Blue: "#3D5AFE",
  ColorSet_Green: "#495242",
  ColorSet_Nil: "#25282C",
};
export const DSersTrackingTemplete = React.memo(() => {
  const [renderData, setRenderData] =
    useState<DsersTrackingCoreV1GetTrackingPageInlineReply>(
      {} as DsersTrackingCoreV1GetTrackingPageInlineReply,
    );

  useEffect(() => {
    const getMessage = (res: any) => {
      console.log("res:", res);
      const isErrorEmail = Object.prototype.hasOwnProperty.call(
        res.data || {},
        "isErrorEmail",
      )
        ? res.data.isErrorEmail
        : true;

      setRenderData(res.data);
    };

    window.parent?.postMessage({ type: "getTemplate" }, "*");

    window.addEventListener("message", getMessage);

    return () => {
      window.removeEventListener("message", getMessage);
    };
  }, []);

  return <TrackingTemplete from="dsers" renderData={renderData} />;
});
